export default "__VITE_ASSET__zzOdauKC__"